<template>
  <div v-if="showBanner" class="verification-banner">
    <BaseAlert variant="warning">
      <div class="verification-banner__content">
        <span class="verification-banner__message">{{ bannerMessage }}</span>
        <div class="verification-banner__actions">
          <!-- TEMPORÁRIO: verificação de telefone desativada (Zenvia suspensa)
          <router-link
            v-if="!isPhoneVerified"
            to="/verificar-telefone"
            class="verification-banner__link"
          >
            Verificar telefone
          </router-link>
          -->
          <BaseButton
            v-if="!isEmailConfirmed"
            variant="link"
            class="verification-banner__link"
            :disabled="isResending"
            @click="handleResendEmail"
          >
            {{ isResending ? "Enviando..." : "Reenviar e-mail" }}
          </BaseButton>
        </div>
      </div>
    </BaseAlert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "VerificationPendingBanner",
  data() {
    return {
      isResending: false
    };
  },
  methods: {
    ...mapActions("user", ["resendEmailConfirmation"]),
    async handleResendEmail() {
      this.isResending = true;
      try {
        await this.resendEmailConfirmation();
        this.$toast.success("E-mail de confirmação reenviado com sucesso.");
      } catch (err) {
        const message =
          err?.response?.data?.error ||
          "Não foi possível reenviar o e-mail. Tente novamente.";
        this.$toast.error(message);
      } finally {
        this.isResending = false;
      }
    }
  },
  computed: {
    // TEMPORÁRIO: isPhoneVerified removido enquanto Zenvia está suspensa
    // ...mapGetters("user", ["isEmailConfirmed", "isPhoneVerified"]),
    ...mapGetters("user", ["isEmailConfirmed"]),
    showBanner() {
      // TEMPORÁRIO: return !this.isEmailConfirmed || !this.isPhoneVerified;
      return !this.isEmailConfirmed;
    },
    bannerMessage() {
      // TEMPORÁRIO: lógica de telefone removida enquanto Zenvia está suspensa
      // if (!this.isEmailConfirmed && !this.isPhoneVerified) {
      //   return "Confirme seu e-mail e seu telefone para poder agendar consultas.";
      // }
      // if (!this.isEmailConfirmed) {
      //   return "Confirme seu e-mail para poder agendar consultas.";
      // }
      // return "Confirme seu telefone para poder agendar consultas.";
      return 'Confirme seu e-mail para poder agendar consultas. Enviamos um pedido de confirmação para seu e-mail — caso não tenha recebido, clique em "Reenviar e-mail" abaixo.';
    }
  }
};
</script>

<style scoped>
.verification-banner__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  flex-wrap: wrap;
}

.verification-banner__actions {
  display: flex;
  gap: var(--space-3);
  flex-shrink: 0;
}

.verification-banner__link {
  font-size: var(--font-size-lg);
  font-weight: var(--fw-semibold);
  color: inherit;
  text-decoration: underline;
  border: 1px solid currentColor;
  border-radius: var(--radius-sm);
  padding: var(--space-2) var(--space-3);
  transition: background-color 0.15s ease;
}

.verification-banner__link:hover:not(:disabled) {
  background-color: rgba(0, 0, 0, 0.06);
}

.verification-banner__link:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
